var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dictionary-entries-widget"},[(_vm.entryUrn)?_c('DictionaryEntry',{attrs:{"entryUrn":_vm.entryUrn}}):_c('DictionaryEntries',{attrs:{"placeholder":_vm.placeholder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }